var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "discipline" },
    [
      _c("c-modal-summary", {
        attrs: {
          active: _vm.isShowSummaryModal,
          type: _vm.summaryTypeLocal,
          title: _vm.summaryModalTitleLocal,
          items: _vm.summaryModalItemsLocal,
        },
        on: {
          close: function ($event) {
            _vm.isShowSummaryModal = false
          },
        },
      }),
      _vm.isDisabledFilters &&
      _vm.tableData.records.length === 0 &&
      !_vm.isDataLoading
        ? _c("div", { staticClass: "discipline-empty" }, [
            _vm._v(" Штрафов, нарушений, поощрений пока нет "),
          ])
        : _vm._e(),
      (_vm.tableData.records.length !== 0 && !_vm.isDataLoading) ||
      (!_vm.isDataLoading && !_vm.isDisabledFilters)
        ? _c("div", { staticClass: "discipline-filters" }, [
            _c(
              "div",
              { staticClass: "discipline-filters-fields" },
              [
                _c("c-input", {
                  staticClass: "discipline-filters-fields-filial",
                  attrs: {
                    items: _vm.filialLocalItems,
                    type: "select",
                    searchable: true,
                    clearable: true,
                    label: "Филиал",
                    placeholder: "Все",
                  },
                  model: {
                    value: _vm.filialLocal,
                    callback: function ($$v) {
                      _vm.filialLocal = $$v
                    },
                    expression: "filialLocal",
                  },
                }),
                _c("c-input", {
                  staticClass: "discipline-filters-fields-measure",
                  attrs: {
                    items: _vm.measureLocalItems,
                    type: "select",
                    label: "Мера",
                    multiple: true,
                    placeholder: "Все",
                  },
                  model: {
                    value: _vm.measureLocal,
                    callback: function ($$v) {
                      _vm.measureLocal = $$v
                    },
                    expression: "measureLocal",
                  },
                }),
                _c("c-input", {
                  ref: "disciplineFilterPeriod",
                  staticClass: "discipline-filters-fields-period",
                  attrs: {
                    label: "За период",
                    placeholder: "00.00.0000 - 00.00.0000",
                    type: "period",
                    icon: "calendar",
                    clearable: true,
                    "icon-right": true,
                  },
                  model: {
                    value: _vm.periodLocal,
                    callback: function ($$v) {
                      _vm.periodLocal = $$v
                    },
                    expression: "periodLocal",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "discipline-filters-buttons" },
              [
                _c("c-button", {
                  staticClass: "discipline-filters-buttons-apply",
                  attrs: { label: "Применить", color: "primary" },
                  on: { click: _vm.applyFilters },
                }),
                _c("c-button", {
                  staticClass: "discipline-filters-buttons-reset",
                  attrs: { label: "Сбросить" },
                  on: { click: _vm.resetFilters },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      (_vm.tableData.records.length !== 0 && !_vm.isDataLoading) ||
      (!_vm.isDataLoading && !_vm.isDisabledFilters)
        ? _c("div", { staticClass: "discipline-summary" }, [
            _c(
              "div",
              {
                staticClass:
                  "discipline-summary-item discipline-summary-item-red",
                on: {
                  click: function ($event) {
                    return _vm.openSummaryModal(
                      "fines",
                      _vm.summaryData.fines.items
                    )
                  },
                },
              },
              [
                _c("div", { staticClass: "discipline-summary-item-title" }, [
                  _vm._v("Штрафы"),
                ]),
                _c("div", { staticClass: "discipline-summary-item-count" }, [
                  _c(
                    "div",
                    { staticClass: "discipline-summary-item-count-text" },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.summaryData.fines.totalCount) + " "
                      ),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "discipline-summary-item-summ" }, [
                  _vm._v(
                    _vm._s(_vm.formatAmount(_vm.summaryData.fines.totalSum)) +
                      " "
                  ),
                  _c("span", [_vm._v("฿")]),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "discipline-summary-item discipline-summary-item-red",
                on: {
                  click: function ($event) {
                    return _vm.openSummaryModal(
                      "fouls",
                      _vm.summaryData.fouls.items
                    )
                  },
                },
              },
              [
                _c("div", { staticClass: "discipline-summary-item-title" }, [
                  _vm._v("Нарушения"),
                ]),
                _c("div", { staticClass: "discipline-summary-item-count" }, [
                  _c(
                    "div",
                    { staticClass: "discipline-summary-item-count-text" },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.summaryData.fouls.totalCount) + " "
                      ),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "discipline-summary-item-summ" }, [
                  _vm._v(
                    _vm._s(_vm.formatAmount(_vm.summaryData.fouls.totalSum)) +
                      " "
                  ),
                  _c("span", [_vm._v("б.")]),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "discipline-summary-item discipline-summary-item-green",
                on: {
                  click: function ($event) {
                    return _vm.openSummaryModal(
                      "bonuses",
                      _vm.summaryData.bonuses.items
                    )
                  },
                },
              },
              [
                _c("div", { staticClass: "discipline-summary-item-title" }, [
                  _vm._v("Поощрения"),
                ]),
                _c("div", { staticClass: "discipline-summary-item-count" }, [
                  _c(
                    "div",
                    { staticClass: "discipline-summary-item-count-text" },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.summaryData.bonuses.totalCount) + " "
                      ),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "discipline-summary-item-summ" }, [
                  _vm._v(
                    _vm._s(_vm.formatAmount(_vm.summaryData.bonuses.totalSum)) +
                      " "
                  ),
                  _c("span", [_vm._v("฿")]),
                ]),
              ]
            ),
          ])
        : _vm._e(),
      (_vm.tableData.records.length !== 0 && !_vm.isDataLoading) ||
      (!_vm.isDataLoading && !_vm.isDisabledFilters)
        ? _c(
            "div",
            { staticClass: "discipline-table" },
            [
              _c("c-data-table-personal-employee", {
                ref: "table",
                staticClass: "discipline-table-table",
                attrs: {
                  levels: 1,
                  "empty-records-label":
                    "Штрафов, нарушений, поощрений пока нет",
                  "disabled-columns": [],
                  "sorted-column": _vm.tableData.sortedColumn,
                  data: _vm.tableData,
                },
                on: { sortedEvent: _vm.refreshTable },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.isDataLoading
        ? _c("c-loader", {
            staticClass: "discipline-loader",
            attrs: {
              label: "Данные загружаются",
              active: _vm.isDataLoading,
              height: "500",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }